import { apiClient } from './apiClient';
import { Account, CreateAccountRequest, UpdateAccountRequest } from './types';

export const accountService = {
  async getAll(): Promise<Account[]> {
    return apiClient.get<Account[]>('/v1/finance-accounts');
  },

  async getById(id: string): Promise<Account> {
    return apiClient.get<Account>(`/v1/finance-accounts/${id}`);
  },

  async create(account: CreateAccountRequest): Promise<Account> {
    return apiClient.post<CreateAccountRequest, Account>('/v1/finance-accounts', account);
  },

  async update(id: string, account: UpdateAccountRequest): Promise<Account> {
    return apiClient.put<UpdateAccountRequest, Account>(`/v1/finance-accounts/${id}`, account);
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/v1/finance-accounts/${id}`);
  },

  async getTotalCapitalInUsd(): Promise<{ actualTotal: number; potentialTotal: number }> {
    return apiClient.get<{ actualTotal: number; potentialTotal: number }>('/v1/finance-accounts/total-capital-usd');
  }
};
